import { render, staticRenderFns } from "./JournalistCard.vue?vue&type=template&id=998b541c&"
import script from "./JournalistCard.vue?vue&type=script&lang=js&"
export * from "./JournalistCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('998b541c')) {
      api.createRecord('998b541c', component.options)
    } else {
      api.reload('998b541c', component.options)
    }
    module.hot.accept("./JournalistCard.vue?vue&type=template&id=998b541c&", function () {
      api.rerender('998b541c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/journalist-card/JournalistCard.vue"
export default component.exports